import { Component, Input, OnChanges } from '@angular/core';

@Component({
    selector: 'app-mdr-progress-bar',
    templateUrl: './mdr-progress-bar.component.html',
    styleUrls: ['./mdr-progress-bar.component.scss'],
    standalone: false,
})
export class MdrProgressBarComponent implements OnChanges {
    @Input() value = 0;
    @Input() maxValue = 100;
    @Input() color = 'blue';
    @Input() minWidth = 0;

    public computedValue = 0;

    constructor() {}

    ngOnChanges(changes: any): void {
        if (changes && changes.maxValue) {
            this.maxValue = changes.maxValue.currentValue;
        }

        if (changes && changes.value) {
            this.value = changes.value.currentValue;
        }

        this.updateProgressBar(this.value, this.maxValue);
    }

    updateProgressBar(value: number, total: number) {
        this.computedValue = (100 * value) / total || 0;
        /**
         * if the progress value > 0 but is very small in comparison with the
         * total we need to set a minimum width of 1px for the progress bar so
         * it will be always visible even for very small values;
         */
        this.minWidth = value > 0 ? 1 : 0;
    }
}
